import { isTimePermissionEnabled } from '../config/applicationFeatures';
import { PERMISSIONS } from '../constants/permissions';
export function normalizePermissions(values: unknown): string[] {
  if (!Array.isArray(values)) return [];
  return [
    ...new Set(
      values
        .map(value => String(value).trim().toUpperCase())
        .filter(Boolean),
    ),
  ];
}

export function hasPermission(
  permissions: readonly string[] | null | undefined,
  permission: string,
): boolean {
  if (!isTimePermissionEnabled() &&
    (permission === PERMISSIONS.PERMISSION_APPLY || permission === PERMISSIONS.PERMISSION_APPROVE)) return false;
  return Array.isArray(permissions) && permissions.includes(permission);
}

export function hasAnyPermission(
  permissions: readonly string[] | null | undefined,
  required: readonly string[],
): boolean {
  return required.some(permission => hasPermission(permissions, permission));
}
